import React from 'react'
import useGetRegistry from 'src/routes/(subdomains)/(my)/[slug]/hooks/useGetRegistry'
import useTrackedUnmarkModal from 'src/routes/(registry)/registry/(gift-tracker-revamp)/hooks/useTrackedUnmarkModal/useTrackedUnmarkModal'
import { Reservation } from 'src/types/reservation'
import useUnmarkAsPurchased from 'src/routes/(registry)/registry/(gift-tracker-revamp)/hooks/useUnmarkAsPurchased/useUnmarkAsPurchased'
import { showUnmarkedAsPurchasedToast } from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/GiftDetailsDrawer/UnmarkedAsPurchasedToast'
import NiceModal from '@ebay/nice-modal-react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Button } from 'baby-design'
import { UnmarkActionProps } from './UnmarkAction.types'

const UnmarkAction: React.FC<UnmarkActionProps> = ({
  onUnmarkedAsPurchased,
  reservation,
}) => {
  const { registry } = useGetRegistry(reservation.registryId.toString())
  const unmarkPurchasedModal = useTrackedUnmarkModal({ reservation })
  const handleUnmarkedAsPurchased = (res: Reservation | undefined) => {
    if (res) {
      onUnmarkedAsPurchased?.(res)
    }
  }
  const {
    mutate: unmarkPurchase,
    ctaText,
    isLoading: isUnmarking,
  } = useUnmarkAsPurchased({
    registry,
    reservation,
    onSuccess: (res: Reservation) => {
      showUnmarkedAsPurchasedToast(registry)
      handleUnmarkedAsPurchased(res)
    },
  })

  const onUnmarkAsPurchased = async () => {
    if (reservation.isSelfPurchase) {
      unmarkPurchase()
    } else {
      // launch warning modal
      const res: Reservation | undefined = await NiceModal.show(
        unmarkPurchasedModal,
        { reservation }
      )
      handleUnmarkedAsPurchased(res)
    }
  }
  return (
    <Button
      loading={isUnmarking}
      size="md"
      variant="destructive"
      onClick={onUnmarkAsPurchased}
    >
      {ctaText}
    </Button>
  )
}

export default UnmarkAction
